'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _actions = require('../../actions');

var _constants = require('../../constants');

var _Button = require('../Core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Dividir = require('../Core/Dividir');

var _Dividir2 = _interopRequireDefault(_Dividir);

var _SerasaConsumidorIcon = require('../Icon/SerasaConsumidorIcon');

var _SerasaConsumidorIcon2 = _interopRequireDefault(_SerasaConsumidorIcon);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rules = function rules(_ref) {
  var loggedIn = _ref.loggedIn,
      mobile = _ref.mobile,
      inScroll = _ref.inScroll;
  return {
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      flex: !loggedIn && mobile && inScroll ? 1 : undefined,
      desktop: {
        flex: 1
      }
    },
    brandButton: {
      padding: mobile && !inScroll ? '0' : undefined
    },
    brand: {
      verticalAlign: 'bottom',
      height: inScroll || mobile ? '24px' : '28px',
      desktop: {
        height: '32px'
      }
    }
  };
};

var brandButton = function brandButton() {
  return {
    display: 'inline-block'
  };
};

var BrandButton = (0, _preactFela.createComponentWithProxy)(brandButton, _Button2.default);

var divider = function divider(_ref2) {
  var inScroll = _ref2.inScroll,
      mobile = _ref2.mobile;
  return _extends({}, inScroll && mobile && {
    marginLeft: '44px'
  });
};

var Divider = (0, _preactFela.createComponentWithProxy)(divider, _Dividir2.default);

var HeaderBrand = function (_Component) {
  _inherits(HeaderBrand, _Component);

  function HeaderBrand() {
    _classCallCheck(this, HeaderBrand);

    return _possibleConstructorReturn(this, (HeaderBrand.__proto__ || Object.getPrototypeOf(HeaderBrand)).apply(this, arguments));
  }

  _createClass(HeaderBrand, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          product = _props.product,
          mobile = _props.mobile,
          loggedIn = _props.loggedIn,
          inScroll = _props.inScroll,
          brand = _props.brand,
          heimdall = _props.heimdall,
          styles = _props.styles;

      var fullWidth = !loggedIn && mobile && inScroll;

      var brandPath = brand.path;
      var brandCallback = brand.callback;
      var brandEl = typeof brandCallback === 'function' ? 'button' : 'a';

      var showIconSC = product !== _constants.SERASA;
      var brandTitle = product !== _constants.SERASA ? _constants.EXTERNAL_SITE_MESSAGE : undefined;
      var productName = _constants.PRODUCTS[product].name;

      var brandImage = void 0;
      var brandAlt = void 0;

      if (brand.logo && (brand.logo.negative || brand.logo.default)) {
        brandImage = brand.logo.negative || brand.logo.default;
        brandAlt = brand.logo.alt || productName;
      } else {
        brandImage = '' + heimdall.host + _constants.PRODUCTS[product].logoWhite;
        brandAlt = productName;
      }

      return (0, _preact.h)(
        'div',
        { className: styles.wrapper },
        !mobile && showIconSC && (0, _preact.h)(
          _Button2.default,
          _extends({ href: '/', onClick: _actions.goSerasaConsumidor, as: 'a', title: brandTitle }, (0, _utils.getAttrsGtm)("Serasa")),
          (0, _preact.h)(_SerasaConsumidorIcon2.default, null)
        ),
        (fullWidth || !mobile && showIconSC) && (0, _preact.h)(Divider, { inScroll: inScroll, mobile: mobile }),
        (0, _preact.h)(
          BrandButton,
          _extends({ href: brandPath, onClick: _actions.goBrandPath, 'aria-label': 'Ir para a p\xE1gina inicial da Serasa', className: styles.brandButton, as: brandEl }, (0, _utils.getAttrsGtm)(productName)),
          (0, _preact.h)('img', { src: brandImage, alt: brandAlt, 'aria-hidden': true, className: styles.brand })
        )
      );
    }
  }]);

  return HeaderBrand;
}(_preact.Component);

exports.default = (0, _preactFela.connect)(rules)(HeaderBrand);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/HeaderBrand.js
// module id = 206
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38